import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-71aa0ef0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M6.93932 7.99998L3.49998 11.4393C3.33525 11.6041 3.25288 11.6864 3.21482 11.7783C3.16407 11.9008 3.16407 12.0385 3.21482 12.161C3.25288 12.2529 3.33525 12.3352 3.49998 12.5C3.66472 12.6647 3.74708 12.7471 3.83897 12.7851C3.96148 12.8359 4.09914 12.8359 4.22165 12.7851C4.31354 12.7471 4.39591 12.6647 4.56064 12.5L7.99998 9.06064L11.4393 12.5C11.6041 12.6647 11.6864 12.7471 11.7783 12.7851C11.9008 12.8359 12.0385 12.8359 12.161 12.7851C12.2529 12.7471 12.3352 12.6647 12.5 12.5C12.6647 12.3352 12.7471 12.2529 12.7851 12.161C12.8359 12.0385 12.8359 11.9008 12.7851 11.7783C12.7471 11.6864 12.6647 11.6041 12.5 11.4393L9.06064 7.99998L12.5 4.56064C12.6647 4.39591 12.7471 4.31354 12.7851 4.22165C12.8359 4.09914 12.8359 3.96148 12.7851 3.83897C12.7471 3.74708 12.6647 3.66472 12.5 3.49998C12.3352 3.33525 12.2529 3.25288 12.161 3.21482C12.0385 3.16407 11.9008 3.16407 11.7783 3.21482C11.6864 3.25288 11.6041 3.33525 11.4393 3.49998L7.99998 6.93932L4.56064 3.49998C4.39591 3.33525 4.31354 3.25288 4.22165 3.21482C4.09914 3.16407 3.96148 3.16407 3.83897 3.21482C3.74708 3.25288 3.66472 3.33525 3.49998 3.49998C3.33525 3.66472 3.25288 3.74708 3.21482 3.83897C3.16407 3.96148 3.16407 4.09914 3.21482 4.22165C3.25288 4.31354 3.33525 4.39591 3.49998 4.56064L6.93932 7.99998Z",
    fill: "#832604",
    "fill-opacity": "0.6"
  })
], -1))
const _hoisted_2 = [
  _hoisted_1
]

import { useStore } from 'vuex'
import { computed, ref, onMounted, withDefaults } from 'vue'
import { usePhoneDomAdaption } from '@/compositions/common'
import { showToastLoading, clearToast } from '@/utils/tools'
import { getUserInsuranceCouponInfo } from '@/apis/insurance'


export default /*#__PURE__*/_defineComponent({
  __name: 'jijia-coupon-info',
  props: {
    sn: { default: '' }
  },
  emits: ['close', 'confirm'],
  setup(__props: any, { emit: emits }) {

const props = __props as { sn: string };



const vueStore = useStore()
const hasCoupon = ref(false)
const couponElId = `el${Date.now()}`
const { phoneDomEmAdaption } = usePhoneDomAdaption()
const appStatusBarHeight = computed<number>(() => vueStore.state.appStatusBarHeight)
const isMiniprogram = computed(() => vueStore.getters.isMiniProgram)
const couponMainImg = 'https://static.knowledge.xag.cn/img/jijia2024/coupon-main.png'
const couponBtnImg = `https://static.knowledge.xag.cn/img/jijia2024/coupon-btn.png`
const getHeaderStyle = computed(() => {
  if (isMiniprogram.value) {
    return '0px'
  }
  return `height: ${44 + appStatusBarHeight.value}px`
})

const mainBgStyle = computed(() => {
  return {
    'background-image': `url(${couponMainImg})`,
  }
})
const btnStyle = computed(() => {
  return {
    'background-image': `url(${couponBtnImg})`,
  }
})
async function checkCouponHandle() {
  showToastLoading()
  try {
    const data = await getUserInsuranceCouponInfo({
      sn: props.sn || '',
    })
    console.log('data', data)
    hasCoupon.value = data.is_exist_equity
  } catch (error) {
    console.log('error', error)
  }
  clearToast()
}

function closeHandle() {
  emits('close')
}
function confirmHandle() {
  emits('confirm')
}
onMounted(() => {
  phoneDomEmAdaption(document.getElementById(couponElId))
})
// checkCouponHandle()

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: "coupon-info-container",
    id: couponElId
  }, [
    _createElementVNode("div", {
      class: "header",
      style: _normalizeStyle(_unref(getHeaderStyle))
    }, null, 4),
    _withDirectives(_createElementVNode("div", {
      class: "main",
      style: _normalizeStyle(_unref(mainBgStyle))
    }, [
      _createElementVNode("div", {
        class: "close-item",
        onClick: closeHandle
      }, _hoisted_2),
      _createElementVNode("div", {
        class: "button",
        style: _normalizeStyle(_unref(btnStyle)),
        onClick: confirmHandle
      }, null, 4)
    ], 4), [
      [_vShow, hasCoupon.value]
    ])
  ], 512)), [
    [_vShow, hasCoupon.value]
  ])
}
}

})